import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InventoryHomePage } from './inventory-home.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: InventoryHomePage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [InventoryHomePage]
})
export class InventoryHomePageModule { }
